<template>
    <b-container>
        <b-card v-if="wardId===null">
            <router-link  :to="{name: 'stake-list'}" active> Back to Stake </router-link>
            <h4>Create a new Congregation.{{wardId}}</h4>
        </b-card>
        <b-card v-if="wardId!==null">
            <b-breadcrumb>
                <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
                <b-breadcrumb-item active>Modify {{ward.ward_name}} Info</b-breadcrumb-item>
            </b-breadcrumb>
            <h1>Name: {{ward.ward_name}}</h1>
        </b-card>
        <b-card>
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-1"
                    label="Name:"
                    label-for="input-1"
                    description="Name.">
                    <b-form-input
                        id="input-1"
                        v-model="ward.ward_name"
                        type="text"
                        placeholder="Enter Name"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-2"
                    label="City:"
                    label-for="input-2"
                    description="City where Congregation is located">
                    <b-form-input
                        id="input-2"
                        v-model="ward.ward_city"
                        type="text"
                        placeholder="Enter City Name"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-3"
                    label="Twilio Phone Number:"
                    label-for="input-3"
                    description="Phone number that is used to send SMS messages,(Must be a twilio phone number)">
                    <b-form-input
                        id="input-3"
                        v-model="ward.twilio_phone_number"
                        type="tel"
                        placeholder="Enter Twilio Phone Number">
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-4"
                    label="Twilio ID:"
                    label-for="input-4"
                    description="Twilio Application Id to use for sending sms">
                    <b-form-input
                        id="input-4"
                        v-model="ward.twilio_id"
                        type="text"
                        placeholder="Enter Twilio Application ID">
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-5"
                    label="Twilio Secret:"
                    label-for="input-5"
                    description="Twilio Application Password to use for sending sms">
                    <b-form-input
                        id="input-5"
                        v-model="ward.twilio_password"
                        type="text"
                        placeholder="Enter Twilio Application Secret/Password">
                    </b-form-input>
                </b-form-group>
        <b-form-group
            id="input-group-10"
            label="Congregation Type"
            label-for="input-group-10"
            description="Type of congregation, mainly used to strip out organizations on creation.">
            <b-form-select v-model="ward.ward_type" :options="wardTypeOptions"></b-form-select>
        </b-form-group>
        <b-form-group
            id="input-group-110"
            label="Ward TimeZone"
            label-for="input-group-110"
            description="The timezone for the ward, this is necessary to use the appoinment features..">
            <b-form-select v-model="ward.ward_timezone" :options="wardTimeZoneOptions"></b-form-select>
        </b-form-group>
        <!-- TODO: needs to be moved out to another component, this will be re-used in a few -->
        <b-form-group label="Congregation Supported Languages" label-for="tags-component-select">
        <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
        <b-form-tags
          id="tags-component-select"
          v-model="ward.supported_languages"
          size="lg"
          class="mb-2"
          add-on-change
          no-outer-focus
        >
          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag
                  @remove="removeTag(tag)"
                  :title="tag"
                  :disabled="disabled"
                  variant="info"
                >{{ tag }}</b-form-tag>
              </li>
            </ul>
            <b-form-select
              v-bind="inputAttrs"
              v-on="inputHandlers"
              :disabled="disabled || availableLanguageOptions.length === 0"
              :options="availableLanguageOptions"
            >
              <template #first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">Choose Languages</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
        </b-form-group>

        <b-form-group label="Ward Appointment Types Supported" label-for="tags-component-select-1">
        <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
        <b-form-tags
          id="tags-component-select-1"
          v-model="ward.appointments_available"
          size="lg"
          class="mb-2"
          add-on-change
          no-outer-focus
        >
          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag
                  @remove="removeTag(tag)"
                  :title="tag"
                  :disabled="disabled"
                  variant="info"
                >{{ tag }}</b-form-tag>
              </li>
            </ul>
            <b-form-select
              v-bind="inputAttrs"
              v-on="inputHandlers"
              :disabled="disabled || availableAppointmentTypes.length === 0"
              :options="availableAppointmentTypes"
            >
              <template #first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">Choose Appointments</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
        </b-form-group>

        <b-form-checkbox v-model="ward.twilio_test" name="check-button" switch>
        Twilio Test(Will simulate but not actually send messages)
        </b-form-checkbox>
        <b-form-checkbox
            v-model="ward.auto_reply_sms"
            name="check-button"
            class="mb-3 mt-3"
            switch>
        Auto reply when receiving SMS (<i>Does not apply to Subscribe/Unsubscribe messages</i>)
        </b-form-checkbox>
        <b-form-checkbox
            v-if="ward.auto_reply_sms"
            v-model="ward.use_ward_org_for_inbound"
            name="check-button"
            class="mb-3 mt-3"
            switch>
        User Ward Org for all Inbound Text Message, default is use contact primary organization.
        </b-form-checkbox>
        <b-form-checkbox
            v-model="ward.send_consent"
            name="check-button"
            class="mb-3 mt-3"
            switch>
        Send a consent message opt-in when contacts are created.
        </b-form-checkbox>
        <b-form-checkbox
            v-model="ward.throttle_sending_sms"
            name="check-button"
            class="mb-3 mt-3"
            switch>
        Throttle the SMS sending to service.<i>This can help if your messages are being filtered by a carrier</i>.
        </b-form-checkbox>
        <b-form-checkbox
            v-model="ward.fetch_contact_carrier"
            name="check-button"
            class="mb-3 mt-3"
            switch>
        Fetch carrier info when creating contact.<i>Please note there is a cost <b-badge variant="danger">$0.005</b-badge> per contact lookup.</i>
        </b-form-checkbox>
        <b-form-checkbox
            v-model="ward.whatsapp_service_enabled"
            name="check-button"
            class="mb-3 mt-3"
            switch>
        Whatsapp Service Enabled.<i>You must first setup whatsapp through twilio to use this service. You will encounter errors when the service is not configured properly in twilio.</i>
        </b-form-checkbox>
        <b-form-checkbox
            v-model="ward.enable_public_signup"
            name="check-button"
            class="mb-3 mt-3"
            switch>
        Public Sign Up Enabled.<i>Enable users to signup through ward public signup page.</i>
        </b-form-checkbox>
        <div v-if="ward.throttle_sending_sms">
        <b-row>
            <b-col>
                <b-form-group
                    id="input-group-7"
                    label="Interval in minutes:"
                    label-for="input-7"
                    description="Interval to release messages in minutes. We have 5 minutes to be good enough. Minimal is 5 minutes and max is 60 minutes">
                    <b-form-spinbutton
                        id="sb-group-7"
                        v-model="ward.throttle_interval_minutes"
                        min="5"
                        max="60"
                        step="5"
                    ></b-form-spinbutton>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                    id="input-group-6"
                    label="Max segments per Interval:"
                    label-for="input-6"
                    description="The total segments to release per interval. We have found 60 to be a good number">
                    <b-form-input
                        id="input-6"
                        v-model="ward.throttle_max_messages"
                        type="number"
                        placeholder="60"
                        >
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        </div>
        <div v-if="isInRole('canFetchContactCarriers')">
            <b-row class="mt-1 mb-3">
                <b-col>
                    <p>
                        <b-button variant="secondary" v-if="wardId!==null" v-on:click="fetchCarriers">Fetch Contact Carriers</b-button> - Fetch contact mobile carriers for a more accurate message cost estimates. Please note there is a cost <b-badge variant="danger">$0.005</b-badge> per contact.<br/>The app will only fetch for this information once and store the results per contact.</p></b-col></b-row>
        </div>
        <div v-if="wardId!==null && !ward.twilio_test" class="mt-3 ml-2">
            <b-row class="mt-3 ml-1">Twilio Phone Number callback URL(Copy and paste into Twilio Project):</b-row>
            <b-row class="ml-1 mt-2"><pre>{{webHookUrl}}</pre></b-row>
        </div>
        <div v-if="wardId!==null && ward.enable_public_signup" class="mt-3 ml-2">
            <b-row class="mt-3 ml-1">Public SignUp URL:</b-row>
            <b-row class="ml-1 mt-1"><pre>{{publicUrl}}</pre></b-row>
            <b-row class="ml-1 mt-1"><b-form-checkbox
            v-model="showPublicQrCode"
            name="check-button"
            class="ml-1 mt-1"
            switch>
        Display QR Code for Signups.<i>Share the QR code with members so they can sign up easily to your ward</i>
        </b-form-checkbox></b-row>
            <b-row v-if="showPublicQrCode" class="ml-1 mt-1"><img :src="'data:image/png;base64,'+ward.public_qr_code" /></b-row>
        </div>
        <b-button type="submit" variant="primary" v-if="wardId!==null">Update</b-button>
        <b-button type="submit" variant="primary" v-if="wardId===null">Create</b-button>
        </b-form>

        </b-card>
    </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { StakeApi } from "@/app/stakes/stakeApi";
import { ROOT_URL } from "@/setup/constants";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
export default {
    name: "WardDetail",
    props: {
        wardId: {
            type: String,
            required: false,
        },
        stakeId: {
            type: String,
            required: false,
        }
    },
    mixins: [userMixin],
    data () {
        return {
            showPublicQrCode: false,
            languageOptions: [],
            wardTypeOptions: [],
            appointmentTypeOptions: [],
            wardTimeZoneOptions: [],
            ward: {
                ward_id: null,
                stake_id: null,
                ward_name: null,
                ward_city: null,
                twilio_phone_number: null,
                twilio_id: null,
                twilio_password: null,
                twilio_test: false,
                use_ward_org_for_inbound: false,
                send_consent: false,
                throttle_sending_sms: false,
                throttle_interval_minutes: 5,
                throttle_max_messages: 60,
                ward_type: 'STANDARD',
                supported_languages: [],
                fetch_contact_carrier: false,
                whatsapp_service_enabled: false,
                appointments_available: [],
                ward_timezone: null,
                enable_public_signup: false,
                public_security_key: null,
                public_qr_code: null
            }
        };
    },
    computed: {
        availableLanguageOptions() {
            return this.languageOptions.filter(opt => this.ward.supported_languages.indexOf(opt.value) === -1);
        },
        availableAppointmentTypes() {
          return this.appointmentTypeOptions.filter(opt => this.ward.appointments_available.indexOf(opt.value) === -1);
        },
        webHookUrl(){
            let hookUrl = `${ROOT_URL}`;
            let revisedHook = hookUrl;
            return `${revisedHook}/hook/${this.wardId}`;
        },
        publicUrl(){
          let publicUrl = `${location.protocol}://${location.host}`;
          this.ward.public_security_key = this.makeWardNameSafe();
          return `${publicUrl}/ward/${this.wardId}/public/signup/${this.ward.public_security_key}`
        }
    },
    async mounted() {
        if(this.wardId!==null) {
          this.ward = await this.getWard();
          await this.getQrCode();
        }
        this.wardTypeOptions = this.$store.state.frontEndSettings.ward_types;
        this.languageOptions = this.$store.state.frontEndSettings.application_languages;
        this.appointmentTypeOptions = this.$store.state.frontEndSettings.appointment_types;
        // fetchTimeZones
        const timeZones = Intl.supportedValuesOf('timeZone');
        timeZones.forEach(timeZone => {
          this.wardTimeZoneOptions.push({
            value: timeZone,
            text: timeZone,
          })
        })

    },
    methods: {
        async getWard() {
            try{
                const { data } = await WardApi.getWardDetail(this.wardId);
                return data.ward;
            } catch(e) {
                handleError(e, "Error trying to get Ward Information");
            }
        },
        async getQrCode() {
          try {
            const { data } = await WardApi.getWardPublicQrCode(this.wardId);
            this.ward.public_qr_code =  data.ward_qr_code;
          } catch (e) {
            handleError(e, "Error trying to get Ward QR Code");
          }
        },
        async onSubmit(event) {
            event.preventDefault();
            try{
                if(this.wardId!==null){
                    const { data } = await WardApi.updateWard(this.wardId, this.ward);
                    this.$toast.success("Updated ward successfully");
                }else{
                    this.ward.stake_id = this.stakeId;
                    const { data } = await StakeApi.createWard(this.stakeId,this.ward);
                    this.ward = data;
                    this.$toast.success("Created ward successfully");
                }
                this.$router.push({ name: 'ward-list',params: { wardId: this.ward.ward_id}});
            } catch (e) {
                handleError(e, "Error trying process Ward request");
            }
        },
        async fetchCarriers() {
            try{
                if(this.wardId!==null){
                    // Bail out when the ward is in test mode
                    if (this.ward.twilio_test) {
                        this.$toast.warning("The ward is in test mode and will not go fetch carriers!");
                        return;
                    }
                    const { data } = await WardApi.fetchCarriers(this.wardId);
                    this.$toast.success("Started fetching of carriers for ward contacts");
                }
            } catch (e) {
                handleError(e, "Error trying process Ward request");
            }
        },
      makeWardNameSafe: function () {
        if (this.ward.ward_name === null)
          return ''
        return this.ward.ward_name.toLowerCase().replaceAll(' ', '-');
      }


    }
}
</script>
<style lang="scss" scoped>
</style>
